import { Disclosure, Menu, Transition } from "@headlessui/react";
import {
  ArrowPathIcon,
  CheckBadgeIcon,
  ChevronDownIcon,
  FunnelIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";

function Category(props) {
  const [products, setProducts] = useState([]);
  const [skip, setSkip] = useState(0);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState();
  const [sort, setSort] = useState("new");
  const [page, setPage] = useState(1);
  const [manufacturer, setManufacturer] = useState();
  const [subtext, setSubtext] = useState("");

  let { catalogue } = useParams();
  console.log(products);
  useEffect(() => {
    axios
      .get(
        "https://dealersonly.parts/beta/api/products?catalogue=" +
          catalogue +
          "&limit=" +
          skip +
          "&query=" +
          q +
          (category ? `&category=${category}` : "") +
          (sort ? `&sort=${sort}` : "") +
          (manufacturer ? `&manufacturer=${manufacturer}` : "")
      )
      .then((res) => {
        setProducts(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [skip, q, manufacturer, sort, category]);

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  useEffect(() => {
    switch (catalogue) {
      case "originalparts":
        setSubtext(
          "Originale und Aftermarketparts in neuem oder gebrauchten Zustand."
        );
        break;
      case "rollingchassis":
        setSubtext("Alles was rollt, original oder modifiziert.");
        break;
      case "suchanfragen":
        setSubtext(
          "Diese Parts werden gesucht, vielleicht liegen Sie in deinem Lager."
        );
        break;
      default:
        setSubtext(
          "Originale und Aftermarketparts in neuem oder gebrauchten Zustand."
        );
        break;
    }
  }, []);

  const nextPage = () => {
    setPage(page + 1);
    setSkip(skip + 20);
  };

  const previousPage = () => {
    if (page <= 1) {
      setSkip(0);
    } else {
      setSkip(skip - 20);
      setPage(page - 1);
    }
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const sortOptions = [
    { name: "Neuste zuerst", href: "#", sort: "new", current: false },
    {
      name: "Preis: günstigste zuerst",
      href: "#",
      sort: "ascending",
      current: false,
    },
    {
      name: "Preis: teuerste zuerst",
      href: "#",
      sort: "descending",
      current: false,
    },
  ];

  return (
    <main className="pb-24">
      <div className='"mx-auto max-w-7xl px-6 py-8 sm:py-10 lg:flex lg:items-center lg:justify-between lg:px-8'>
        <Link
          to="/shop"
          className="text-indigo-600 font-medium place-self-start sticky top-5 z-50"
        >
          <span aria-hidden="true">←</span>
          Zurück zur Startpage
        </Link>
        <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
          <Link
            to="../../listings/new"
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Part einstellen
          </Link>
          {/* <button type='button' className="text-sm font-semibold leading-6 text-gray-900">
                Shop durchsuchen <span aria-hidden="true">→</span>
              </button> */}
        </div>
      </div>
      <div className="py-16 px-4 text-center sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900">
          {catalogue.toUpperCase()}
        </h1>
      </div>

      {/* Filters */}
      <Disclosure
        as="section"
        aria-labelledby="filter-heading"
        className="grid items-center border-gray-200"
      >
        <h2 id="filter-heading" className="sr-only">
          Filter
        </h2>
        <div className="relative col-start-1 row-start-1 py-4">
          <div className="mx-auto flex max-w-7xl space-x-6 divide-x divide-gray-200 px-4 text-sm sm:px-6 lg:px-8">
            <div className="flex flex-1 items-center px-2 justify-start">
              <div className="max-w-xs lg:max-w-xs">
                <label htmlFor="search" className="sr-only">
                  Suchen
                </label>
                <div className="relative">
                  <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <MagnifyingGlassIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </div>
                  <input
                    id="search"
                    name="search"
                    className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 leading-5 placeholder-gray-500 focus:border-indigo-500 focus:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                    placeholder="Suchen"
                    type="search"
                    value={q}
                    onChange={(e) => {
                      setQ(e.target.value);
                      setSkip(0);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row-start-1 py-4">
          <div className="mx-auto flex max-w-7xl justify-end px-4 sm:px-6 lg:px-8">
            <Menu as="div" className="relative inline-block">
              <div className="flex">
                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Sortieren
                  <ChevronDownIcon
                    className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {sortOptions.map((option) => (
                      <Menu.Item key={option.name}>
                        {({ active }) => (
                          <button
                            onClick={() => {
                              setSkip(0);
                              setPage(1);
                              setSort(option.sort);
                            }}
                            className={classNames(
                              active
                                ? "bg-gray-100 font-medium text-gray-900"
                                : "text-gray-500",
                              "block px-4 py-2 text-sm text-left"
                            )}
                          >
                            {option.name}
                          </button>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
      </Disclosure>

      {/* Product grid */}
      {products.length !== 0 && (
        <section
          aria-labelledby="products-heading"
          className="mx-auto max-w-7xl overflow-hidden sm:px-6 lg:px-8"
        >
          <h2 id="products-heading" className="sr-only">
            Artikel
          </h2>

          <div className="-mx-px grid grid-cols-2 border-gray-200 sm:mx-0 md:grid-cols-3 lg:grid-cols-4">
            {products?.data?.map((product) => (
              <div
                key={product._id}
                className={`group relative border-t border-b border-gray-200 bg-white shadow-sm sm:rounded-lg sm:border p-4 m-1 ${
                  product.active ? "" : "opacity-50"
                }`}
              >
                {product.selector === "parts" && product.oem === "Original" ? (
                  <div className="flex items-center text-sm font-medium text-indigo-600 mb-2 z-10">
                    <CheckBadgeIcon
                      className="mr-2 h-6 w-6 flex-none"
                      aria-hidden="true"
                    />
                    <p>OEM Part</p>
                  </div>
                ) : (
                  <div className="flex items-center text-sm font-medium text-red-50-600 mb-2 z-10 invisible">
                    <ArrowPathIcon
                      className="mr-2 h-6 w-6 flex-none"
                      aria-hidden="true"
                    />
                    <p>Aftermarket</p>
                  </div>
                )}
                <div className="aspect-w-1 aspect-w-1-custom aspect-h-1 overflow-hidden rounded-lg bg-gray-200 group-hover:opacity-75">
                  <img
                    src={
                      product.productImages &&
                      product.productImages[0] &&
                      product.productImages[0]
                        ? "https://dealersonly.parts/beta/app/" +
                          product.productImages[0]
                        : "https://dealersonly.parts/beta/app/files/DopePlaceholder.png"
                    }
                    alt={product.imageAlt}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="pt-6 pb-2 text-center">
                  <h3 className="text-sm font-medium text-gray-900">
                    {product.active ? (
                      <Link to={`../product/${product.handle}`}>
                        <span aria-hidden="true" className="absolute inset-0" />
                        {product.title}
                      </Link>
                    ) : (
                      product.title
                    )}
                  </h3>

                  <p className="mt-2 text-base font-medium text-gray-900">
                    {formatter.format(product.price)}
                  </p>
                  <div className="flex gap-2">
                    {product.selector === "parts" ? (
                      product.teileNummer &&
                      product.teileNummer.map((element) => {
                        return (
                          <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                            {element ? `#${element}` : ""}
                          </p>
                        );
                      })
                    ) : (
                      <>
                        <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                          {product.category}
                        </p>
                        <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                          {product.baujahr}
                        </p>
                        <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                          {product.motor}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
      {/* Pagination */}
      <nav
        aria-label="Pagination"
        className="mx-auto mt-6 flex max-w-7xl justify-between px-4 text-sm font-medium text-gray-700 sm:px-6 lg:px-8"
      >
        <div className="min-w-0 flex-1">
          <button
            onClick={() => previousPage()}
            className="inline-flex h-10 items-center rounded-md border border-gray-300 bg-white px-4 hover:bg-gray-100 focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-opacity-25 focus:ring-offset-1 focus:ring-offset-indigo-600"
          >
            Vorherige
          </button>
        </div>
        <div className="hidden space-x-2 sm:flex">
          {/* Current: "border-indigo-600 ring-1 ring-indigo-600", Default: "border-gray-300" */}
          <button
            type="button"
            className="inline-flex h-10 items-center rounded-md border border-gray-300 bg-white px-4 hover:bg-gray-100 focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-opacity-25 focus:ring-offset-1 focus:ring-offset-indigo-600"
          >
            {page}
          </button>
        </div>
        <div className="flex min-w-0 flex-1 justify-end">
          <button
            onClick={() => nextPage()}
            type="button"
            className="inline-flex h-10 items-center rounded-md border border-gray-300 bg-white px-4 hover:bg-gray-100 focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-opacity-25 focus:ring-offset-1 focus:ring-offset-indigo-600"
          >
            Nächste
          </button>
        </div>
      </nav>
    </main>
  );
}

export default Category;
